/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

export const SCORM_PLAYER_ROOT = 'scorm-player';
export const SCORM_PLAYER_RETURN_URL_PARAM = 'returnUrl';

export function scormPlayerPath(scormUri: string): string[] {
  return ['/', SCORM_PLAYER_ROOT, scormUri];
}
